import { Selection } from 'prosemirror-state';
import { isInTable } from 'prosemirror-tables';
export const exitTable = (node) => (state, dispatch) => {
    if (!isInTable(state)) {
        return false;
    }
    const { $head } = state.selection;
    const pos = $head.after();
    const tr = state.tr.replaceWith(pos, pos, node.createAndFill());
    tr.setSelection(Selection.near(tr.doc.resolve(pos), 1));
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr.scrollIntoView());
    return true;
};
//# sourceMappingURL=command.js.map